// src/pages/CartPage.js
import React, { useContext, useEffect, useState } from 'react';
import { CartContext } from '../context/CartContext';
import Footer from '../components/footer';
import { Link } from 'react-router-dom';
import '../styles/CartPage.css'

export default function CartPage() {
  const { cart, updateQuantity, removeFromCart } = useContext(CartContext);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setTotal(cart.reduce((sum, item) => sum + item.subtotal, 0));
  }, [cart]);

  return (
    <>
      <div className="p-10 max-w-4xl mx-auto bg-white rounded-lg shadow">
        <h1 className="text-2xl font-bold mb-4">Your Cart</h1>
{cart.length === 0 ? (
  <p>Your cart is empty</p>
) : (
  cart.map(item => (
    <div key={item.productId._id} className="cart-item">
      <Link to={`/product/${item.productId._id}`} className="w-[30%]">
        <img
          src={item.productImage}
          alt={item.name}
          className="object-cover rounded-lg"
        />
      </Link>

      <div className="cart-item-details">
        <h2 className="font-bold text-[32px] uppercase">{item.brand}</h2>
        <h2 className="font-semibold capitalize text-navtext">{item.name}</h2>
        <p className="text-currentnav font-medium">
          Unit Price: ${item.productId.price.toFixed(2)}
        </p>

        <div className="flex mt-12">
          <div className="font-bold text-[24px] text-currentnav">
            <p>Subtotal: ${item.subtotal.toFixed(2)}</p>
          </div>
          <div className="ml-4 mt-2">
            <button
              onClick={() => removeFromCart(item.productId._id)}
              className="font-normal text-[18px] text-gray-600"
            >
              <i className="bxr bx-trash"></i> Remove
            </button>
          </div>
        </div>
      </div>

      <div className="cart-item-qty flex flex-row">
        <button
          onClick={() => updateQuantity(item.productId._id, item.quantity - 1)}
          disabled={item.quantity === 1}
        >
          −
        </button>
        <span>{item.quantity}</span>
        <button
          onClick={() => updateQuantity(item.productId._id, item.quantity + 1)}
        >
          +
        </button>
      </div>
    </div>
  ))
)}

        <div className="mt-6">
          <Link to="/" className="text-currentnav hover:underline"><i class='bxr  bx-arrow-left-stroke'  ></i> Continue Shopping</Link>
        </div>
        <div className="mt-6 text-right">
          <h3 className="font-bold text-[30px] text-currentnav">Total: ${total.toFixed(2)}</h3>
        </div>
      </div>

      <div className="max-w-4xl justify-center items-center flex mx-auto mt-20 mb-10">
  <Link
    to="/checkout"
    className="text-white px-6 py-3 rounded-3xl transition duration-300 shadow-lg hover:scale-105 hover:shadow-xl"
    style={{
      backgroundColor: 'rgba(244, 147, 0, 1)', 
      boxShadow: '0 0 15px rgba(244, 147, 0, 0.8), 0 0 30px rgba(244, 147, 0, 0.5)',
    }}
  >
    Proceed to Checkout
  </Link>
</div>

      <Footer />
    </>
  );
}
